import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useCreateClient = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, isError } = useMutationState({
        mutationFn: (vars)=>api.client.create(vars),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.Clients
                ]
            });
        }
    });
    return {
        createClient: mutateAsync,
        isLoading,
        isError
    };
};
export const useUpdateClient = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, isError } = useMutationState({
        mutationFn: (param)=>{
            let { clientId, name, clientType } = param;
            return api.client.update(clientId, {
                name,
                clientType
            });
        },
        onSuccess: (_result, param)=>{
            let { clientId } = param;
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.Client,
                    clientId
                ]
            });
        }
    });
    return {
        updateClient: mutateAsync,
        isLoading,
        isError
    };
};
export const useCreateClientContact = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, isError } = useMutationState({
        mutationFn: (_0)=>{
            let { clientId } = _0, data = _object_without_properties(_0, [
                "clientId"
            ]);
            return api.client.createContact(clientId, data);
        },
        onSuccess: (_result, param)=>{
            let { clientId } = param;
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ClientContacts,
                    clientId
                ]
            });
        }
    });
    return {
        createClientContact: mutateAsync,
        isLoading,
        isError
    };
};
export const useUpdateClientContact = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, isError } = useMutationState({
        mutationFn: (_0)=>{
            let { clientId, contactId } = _0, data = _object_without_properties(_0, [
                "clientId",
                "contactId"
            ]);
            return api.client.updateContact(clientId, contactId, data);
        },
        onSuccess: (_result, param)=>{
            let { clientId } = param;
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ClientContacts,
                    clientId
                ]
            });
        }
    });
    return {
        updateClientContact: mutateAsync,
        isLoading,
        isError
    };
};
